import React, { Component } from "react";
import Helmet from "react-helmet";

export function mapImageUrl(url, optimized = true) {
  if (optimized) {
    if (optimized === true) {
      url = `/optimized${url}?w=${window.innerWidth}`;
    } else if (!optimized.mode) {
      if (optimized.width) {
        url = `/optimized${url}?w=${optimized.width}`;
      } else if (optimized.height) {
        url = `/optimized${url}?h=${optimized.height}`;
      }
    } else {
      if (optimized.size) {
        url = `/optimized${url}?h=${optimized.size}&w=${optimized.size}&m=${optimized.mode}`;
      } else {
        url = `/optimized${url}?h=${optimized.height}&w=${optimized.width}&m=${optimized.mode}`;
      }
    }

    if (optimized !== true && "quality" in optimized) {
      url += `&q=${optimized.quality}`;
    }
  }
  return mapUrl(url);
}

export function mapUrl(url) {
  return url; // ? 'http://localhost:53412' + url : null;
}

export class DisplayHtml extends Component {
  render() {
    return <span dangerouslySetInnerHTML={{ __html: this.props.html }} />;
  }
}

export function generateSEO(cmsPageSEO, canonicalPath = "") {
  if (!cmsPageSEO) return null;

  const { 
    Title = "Union Street Inn - Nantucket's Premier Boutique Hotel", 
    Description, 
    Keywords 
  } = cmsPageSEO;

  // Only allow indexing in production
  const isProduction = process.env.NODE_ENV === "production";
  const robotsContent = isProduction
    ? "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
    : "noindex, nofollow";

  // Build canonical URL - use provided path or fall back to current location
  const baseUrl = "https://unioninn.com";
  const canonicalUrl = canonicalPath 
    ? `${baseUrl}${canonicalPath}` 
    : (typeof window !== 'undefined' ? window.location.href : baseUrl);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{Title}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="description" content={Description} />
      <meta name="keywords" content={Keywords} />
      <meta name="robots" content={robotsContent} />
      <meta name="googlebot" content={robotsContent} />
      <meta name="bingbot" content={robotsContent} />
      
      {/* Open Graph */}
      <meta property="og:title" content={Title} />
      <meta property="og:description" content={Description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={Title} />
      <meta name="twitter:description" content={Description} />
    </Helmet>
  );
}

export function convertNullToUndefined(obj) {
  if (obj === null) return undefined;
  if (typeof obj === "object") {
    for (let key in obj) {
      obj[key] = convertNullToUndefined(obj[key]);
    }
  }
  return obj;
}
